"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageOpportunityUnarchiveErrorType = exports.CoverageOpportunityArchiveErrorType = exports.PolicyStatus = exports.CoverageOpportunityStatusReason = exports.CoverageOpportunityStatus = void 0;
var CoverageOpportunityStatus;
(function (CoverageOpportunityStatus) {
    CoverageOpportunityStatus["ACTIVE"] = "ACTIVE";
    CoverageOpportunityStatus["ARCHIVED"] = "ARCHIVED";
})(CoverageOpportunityStatus = exports.CoverageOpportunityStatus || (exports.CoverageOpportunityStatus = {}));
var CoverageOpportunityStatusReason;
(function (CoverageOpportunityStatusReason) {
    CoverageOpportunityStatusReason["DATA_CLEANUP"] = "DATA_CLEANUP";
    CoverageOpportunityStatusReason["COVERAGE_OPPORTUNITY_GROUP_ARCHIVED"] = "COVERAGE_OPPORTUNITY_GROUP_ARCHIVED";
    CoverageOpportunityStatusReason["COVERAGE_OPPORTUNITY_GROUP_UNARCHIVED"] = "COVERAGE_OPPORTUNITY_GROUP_UNARCHIVED";
    CoverageOpportunityStatusReason["CREATED"] = "CREATED";
    CoverageOpportunityStatusReason["MANUALLY_ARCHIVED"] = "MANUALLY_ARCHIVED";
    CoverageOpportunityStatusReason["MANUALLY_UNARCHIVED"] = "MANUALLY_UNARCHIVED";
    CoverageOpportunityStatusReason["QUOTING_PLAN_ARCHIVED"] = "QUOTING_PLAN_ARCHIVED";
})(CoverageOpportunityStatusReason = exports.CoverageOpportunityStatusReason || (exports.CoverageOpportunityStatusReason = {}));
var PolicyStatus;
(function (PolicyStatus) {
    PolicyStatus["ACTIVE"] = "ACTIVE";
    PolicyStatus["EXPIRED"] = "EXPIRED";
    PolicyStatus["CANCELLED"] = "CANCELLED";
    PolicyStatus["UPCOMING"] = "UPCOMING";
})(PolicyStatus = exports.PolicyStatus || (exports.PolicyStatus = {}));
var CoverageOpportunityArchiveErrorType;
(function (CoverageOpportunityArchiveErrorType) {
    CoverageOpportunityArchiveErrorType["COVERAGE_OPPORTUNITY_GROUP_IS_NOT_ARCHIVED"] = "COVERAGE_OPPORTUNITY_GROUP_IS_NOT_ARCHIVED";
    CoverageOpportunityArchiveErrorType["HAS_POLICY_ASSOCIATED"] = "HAS_POLICY_ASSOCIATED";
})(CoverageOpportunityArchiveErrorType = exports.CoverageOpportunityArchiveErrorType || (exports.CoverageOpportunityArchiveErrorType = {}));
var CoverageOpportunityUnarchiveErrorType;
(function (CoverageOpportunityUnarchiveErrorType) {
    CoverageOpportunityUnarchiveErrorType["COVERAGE_OPPORTUNITY_GROUP_IS_ARCHIVED"] = "COVERAGE_OPPORTUNITY_GROUP_IS_ARCHIVED";
})(CoverageOpportunityUnarchiveErrorType = exports.CoverageOpportunityUnarchiveErrorType || (exports.CoverageOpportunityUnarchiveErrorType = {}));
//# sourceMappingURL=coverage-opportunity.js.map